(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-abandonment-popup"] && !Shopify.designMode) return;
  try {
    (function() {
    var STORAGE_KEY = 'tm_abandon_shown';
    var CHECKOUT_KEY = 'tm_checked_out';
    var overlay = document.getElementById('tm-abandon-popup');
    if (!overlay) return;
    if (localStorage.getItem(CHECKOUT_KEY)) return;

    var timer;
    var shown = false;

    function showPopup() {
      if (shown || localStorage.getItem(CHECKOUT_KEY)) return;
      shown = true;
      overlay.classList.add('tm-visible');
    }

    function resetTimer() {
      clearTimeout(timer);
      var btn = document.getElementById('tm-popup-checkout-btn');
      var secs = btn ? (parseInt(btn.getAttribute('data-ab-delay'), 10) || 60) : 60;
      timer = setTimeout(showPopup, secs * 1000);
    }

    document.getElementById('tm-popup-close').addEventListener('click', function() {
      overlay.classList.remove('tm-visible');
    });

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.classList.remove('tm-visible');
    });

    document.getElementById('tm-popup-checkout-btn').addEventListener('click', function() {
      localStorage.setItem(CHECKOUT_KEY, '1');
    });

    ['mousemove','keydown','scroll','touchstart','click'].forEach(function(evt) {
      document.addEventListener(evt, resetTimer, { passive: true });
    });

    resetTimer();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-buy-button"] && !Shopify.designMode) return;
  try {
    (function () {
  var bar = document.getElementById('tm-sticky-buy');
  var btn = document.getElementById('tm-sticky-buy-btn');
  if (!bar || !btn) return;

  /* show/hide when main ATC scrolls out of view */
  var target = document.querySelector('.product-form__buttons');
  if (target && window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      var vis = entries[0].isIntersecting;
      bar.classList.toggle('tm-sticky-buy--visible', !vis);
      bar.setAttribute('aria-hidden', vis ? 'true' : 'false');
    }, { threshold: 0.1 }).observe(target);
  } else {
    window.addEventListener('scroll', function () {
      var past = window.scrollY > 350;
      bar.classList.toggle('tm-sticky-buy--visible', past);
    }, { passive: true });
  }

  /* sync variant id */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('product-variant-id')) {
      btn.dataset.variantId = e.target.value;
    }
  });
  document.addEventListener('variant:change', function (e) {
    if (e.detail && e.detail.variant) {
      btn.dataset.variantId = e.detail.variant.id;
      var priceEl = bar.querySelector('.tm-sticky-buy__price');
      if (priceEl && e.detail.variant.price) {
        priceEl.textContent = window.Shopify && Shopify.formatMoney
          ? Shopify.formatMoney(e.detail.variant.price)
          : 'Rs.' + (e.detail.variant.price / 100).toFixed(0);
      }
    }
  });

  /* periodic wiggle */
  function scheduleWiggle() {
    setTimeout(function () {
      if (bar.classList.contains('tm-sticky-buy--visible')) {
        btn.classList.add('tm-wiggle');
        btn.addEventListener('animationend', function () {
          btn.classList.remove('tm-wiggle');
          scheduleWiggle();
        }, { once: true });
      } else { scheduleWiggle(); }
    }, 4000);
  }
  scheduleWiggle();

  /* click: add to cart then open drawer */
  btn.addEventListener('click', function () {
    if (btn.disabled) return;
    var variantInput = document.querySelector('.product-variant-id');
    var variantId = (variantInput && variantInput.value) || btn.dataset.variantId;
    var qtyInput = document.querySelector('.quantity__input');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    btn.disabled = true;
    btn.classList.add('tm-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      /* try to open cart drawer first */
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function () { window.location.href = '/cart'; })
    .finally(function () {
      btn.disabled = false;
      btn.classList.remove('tm-loading');
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-checkout-bar"] && !Shopify.designMode) return;
  try {
    (function() {
    var bar = document.getElementById('tm-sticky-bar');
    if (!bar) return;

    var mainBtn = document.querySelector('[name="checkout"], .cart__checkout-button, .cart-checkout-button, [href*="checkout"]');

    function checkVisibility() {
      if (!mainBtn) {
        bar.classList.add('tm-bar-visible');
        bar.removeAttribute('aria-hidden');
        return;
      }
      var rect = mainBtn.getBoundingClientRect();
      var inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
      bar.classList.toggle('tm-bar-visible', !inView);
      bar.setAttribute('aria-hidden', inView ? 'true' : 'false');
    }

    document.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility, { passive: true });
    checkVisibility();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["urgency-banner"] && !Shopify.designMode) return;
  try {
    /* FIX A — UTC+5 arithmetic avoids toLocaleString failure on iOS/Android */
  (function() {
    var countdownEl = document.getElementById('tm-countdown');
    if (!countdownEl) return;

    function tick() {
      try {
        var now = new Date();
        var utc = now.getTime() + (now.getTimezoneOffset() * 60000);
        var pk  = new Date(utc + (5 * 3600000));
        var cutoff = new Date(pk);
        cutoff.setHours(15, 0, 0, 0);
        if (pk >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
        var diff = Math.max(0, Math.floor((cutoff - pk) / 1000));
        var h = Math.floor(diff / 3600);
        var m = Math.floor((diff % 3600) / 60);
        var s = diff % 60;
        countdownEl.textContent =
          String(h).padStart(2,'0') + ':' +
          String(m).padStart(2,'0') + ':' +
          String(s).padStart(2,'0');
      } catch(e) {
        var wrap = countdownEl.closest('.tm-urgency-banner');
        if (wrap) wrap.style.display = 'none';
      }
    }
    tick();
    setInterval(tick, 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["viewer-count"] && !Shopify.designMode) return;
  try {
    /* FIX B — sessionStorage seed keeps count consistent per session */
  (function() {
    try {
      var el = document.getElementById('tm-cart-viewers');
      if (!el) return;
      var seed = parseInt(sessionStorage.getItem('tm_cart_view') || '0');
      if (!seed) { seed = Math.floor(Math.random() * 15) + 5; sessionStorage.setItem('tm_cart_view', seed); }
      var drift = Math.floor(Date.now() / 30000) % 3;
      el.textContent = '🔥 ' + Math.max(1, seed + drift) + ' people viewing this right now';
      setInterval(function() {
        drift = Math.floor(Date.now() / 30000) % 3;
        el.textContent = '🔥 ' + Math.max(1, seed + drift) + ' people viewing this right now';
      }, 30000);
    } catch(e) {}
  })();
  } catch(e) { console.error(e); }
})();

})();
